<div class="container">
    <router-outlet *ngIf="isLoadUser"></router-outlet>
</div>